import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import { PolicyLayout, PolicySection } from "./Terms";
import "../css/terms.scss";

const sections = [
  { id: "orders", label: "Orders" },
  { id: "products", label: "Products and allergens" },
  { id: "delivery", label: "Delivery" },
  { id: "returns", label: "Returns and support" },
];

function Faqs() {
  return (
    <PolicyLayout eyebrow="Help · FAQs" intro={`Quick answers about shopping with ${siteConfig.brandName}.`} modifier="faqs" sections={sections} title="Frequently asked questions">
      <PolicySection id="orders" title="1. Orders">
        <h3>Can I change an order after payment?</h3>
        <p>Email <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a> promptly. We will help when processing has not started.</p>
        <h3>Which currency is used?</h3><p>All displayed prices and checkout totals are in USD.</p>
      </PolicySection>
      <PolicySection id="products" title="2. Products and allergens">
        <h3>Where can I find ingredients?</h3><p>Ingredients, storage guidance, weight, and serving information appear on each product page.</p>
        <h3>Can you guarantee an allergen-free product?</h3><p>No. Contact us before ordering and always review the physical label; cross-contact can occur.</p>
      </PolicySection>
      <PolicySection id="delivery" title="3. Delivery">
        <h3>How are temperature-sensitive foods packed?</h3><p>Insulated materials and cold packs are used when needed. See our <Link to="/shipping">shipping policy</Link> for details.</p>
        <h3>When will my order arrive?</h3><p>Timing is shown during checkout and may vary with destination, weather, and carrier conditions.</p>
      </PolicySection>
      <PolicySection id="returns" title="4. Returns and support">
        <h3>What if an item arrives damaged?</h3><p>Keep the item and packaging, take clear photos, and email us within the window listed in our <Link to="/returns">returns policy</Link>.</p>
        <h3>How do I contact doszenith?</h3><p>Email <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a> or use the <Link to="/contact">contact form</Link>.</p>
      </PolicySection>
    </PolicyLayout>
  );
}

export default Faqs;
